import { render } from "./ImageRadioButton.vue?vue&type=template&id=5641275a&scoped=true&ts=true"
import script from "./ImageRadioButton.vue?vue&type=script&lang=ts"
export * from "./ImageRadioButton.vue?vue&type=script&lang=ts"

import "./ImageRadioButton.vue?vue&type=style&index=0&id=5641275a&lang=scss&scoped=true"
import "./ImageRadioButton.vue?vue&type=style&index=1&id=5641275a&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5641275a"]])

export default __exports__